var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import * as BetType from '../../../constants/BetType';
import { defineMessages, FormattedMessage } from 'react-intl';
import BetTypesItem from './BetTypesItem';
var messages = defineMessages({
    bet_type_ordinar: {
        id: 'bet_type.ordinar',
        defaultMessage: 'Single'
    },
    bet_type_accumulator: {
        id: 'bet_type.accumulator',
        defaultMessage: 'Combo'
    },
    bet_type_loseToWinAccumulator: {
        id: 'bet_type.loseToWinAccumulator',
        defaultMessage: 'Lose-to-Win Combo'
    },
    bet_type_system_2: {
        id: 'bet_type.system_2',
        defaultMessage: 'System'
    },
});
var BetTypes = /** @class */ (function (_super) {
    __extends(BetTypes, _super);
    function BetTypes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetTypes.prototype.render = function () {
        var _a = this.props, betTypes = _a.betTypes, selectedBetType = _a.selectedBetType, betSlipsSize = _a.betSlipsSize;
        var betType = selectedBetType.betType;
        var express = betTypes.find(function (b) { return b.type === BetType.EXPRESS; });
        var system = betTypes.find(function (b) { return b.type === BetType.SYSTEM; });
        var props = {
            betTypes: betTypes,
            selectBetTypeAction: this.props.selectBetTypeAction,
            selectedBetType: betType,
            saveBetTypeAction: this.props.saveBetTypeAction
        };
        return (betSlipsSize > 1 &&
            _jsx("div", __assign({ className: 'slider' }, { children: _jsxs("ul", { children: [_jsx(BetTypesItem, __assign({}, props, { betType: BetType.SINGLE, msg: _jsx(FormattedMessage, __assign({}, messages.bet_type_ordinar)) })), express &&
                            _jsx(BetTypesItem, __assign({}, props, { betType: BetType.EXPRESS, msg: _jsx(FormattedMessage, __assign({}, messages.bet_type_accumulator)) })), system &&
                            _jsx(BetTypesItem, __assign({}, props, { betType: BetType.SYSTEM, msg: _jsx(FormattedMessage, __assign({}, messages.bet_type_system_2)) }))] }) })));
    };
    return BetTypes;
}(React.Component));
BetTypes.propTypes = {
    selectBetTypeAction: PropTypes.func.isRequired,
    betTypes: PropTypes.object.isRequired,
    selectedBetType: PropTypes.object.isRequired,
    betSlipsSize: PropTypes.number.isRequired
};
export default BetTypes;



// WEBPACK FOOTER //
// ./src/components/coupon/betSlip/BetTypes.jsx